export default __webpack_public_path__ + "static/media/tray_rest.6797557b.png";